import React, { useEffect, useRef, useState } from 'react';
import { IoClose } from "react-icons/io5";
import { BrowserView, isMobile, isTablet } from 'react-device-detect';
import { fmesh, foundFeature } from '../../../core/globalVariables.js';
import Drawer from 'react-modern-drawer';
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import Chart from "chart.js/auto";
import { MdOutlineAddToPhotos } from "react-icons/md";
import { CgMenuGridO } from "react-icons/cg";
import { MdOutlineLayers } from "react-icons/md";

const PDFParcelInfo = ({
    isVisible,
    polygonCustomLayerRef,
    clickedInfoHeader,
    globalState,
    longstandingGeoJSONRef,
    originalGeoJSONforComparingRef,
    PDFParcelInfoRef
}) => {
    const [activeTab, setActiveTab] = useState("GROUP");
    const [modalOtherOriginal, setmodalOtherOriginal] = useState(null);
    const [modalOtherAmended, setmodalOtherAmended] = useState(null);
    const [modalSkylarkId, setModalSkylarkId] = useState(null);
    const [selectedMetricValue, setSelectedMetricValue] = useState(null);
    const [selectedKeyValue, setSelectedKeyValue] = useState(null);
    const [landKeySelectedKeyColourOriginal, setlandKeySelectedKeyColourOriginal] = useState(null);
    const [landKeySelectedKeyColourAmended, setlandKeySelectedKeyColourAmended] = useState(null);
    const [totalSumMetric, setTotalSumMetric] = useState(0);
    const [totalSumMetricOriginal, setTotalSumMetricOriginal] = useState(0);
    const [totalSumsValue, setTotalSumsValue] = useState(null);
    const [totalSumsValueOriginal, setTotalSumsValueOriginal] = useState(null);
    const [isRighdivrawerVisible, setIsRighdivrawerVisible] = useState(false);
    const [multilayerDetails, setMultilayerDetails] = useState('');

    const [multilayerOriginalGroupDetails, setMultilayerOriginalGroupDetails] = useState('');
    const [multiGroupDetails, setMultilayerGroupDetails] = useState('');

    const [multilayerOriginalParcelDetails, setMultilayerOriginalParcelDetails] = useState('');
    const [multiParcelDetails, setMultilayerParcelDetails] = useState('');

    const [valuesFromGroupData, setValuesFromGroupData] = useState('');

    const [moreThanOneLayer, setMoreThenOneLayer] = useState(false);

    const [moreThanOnePolygonSelected, setMoreThenOnePolygonSelected] = useState(false);

    let selectedYearEditing = globalState.selectedYearEditing;
    let setIsVisible = globalState.setIsVisible;
    let selectedMetric = globalState.selectedMetric;
    let landKeySelectedKey = globalState.landKeySelectedKey;
    let hasChangedKeyValue = globalState.hasChangedKeyValue;
    let multiLayerSelected = globalState.multiLayerSelected;
    let setMultiLayerSelected = globalState.setMultiLayerSelected;
    let multuLayerSelectedArray = globalState.multuLayerSelectedArray;
    let setMultuLayerSelectedArray = globalState.setMultuLayerSelectedArray;
    let layers = globalState.layers;
    let greoupingSelected = globalState.greoupingSelected;
    let setGreoupingSelected = globalState.setGreoupingSelected;
    let multuGroupSelectedArray = globalState.multuGroupSelectedArray;
    let setMultuGroupSelectedArray = globalState.setMultuGroupSelectedArray;

    const ctxPDFgroupRef = useRef();
    const ParcelcharbykeytRef = useRef();

    const ParcelchartoriginalRef = useRef();
    const ParcelcharbykeytoriginalRef = useRef();

    const ParcelchartParcelOriginalRef = useRef();
    const ParcelchartParcelAmendedRef = useRef();

    const combinedGroupChartRef = useRef();

    const PDFcombinedChartRef = useRef();

    const ctxPDFtotalSumSummaryUseRef = useRef();

    let mobileStatus = isMobile ? "mobile" : "not-mobile";

    if (isTablet) mobileStatus = "not-mobile";

    useEffect(() => {
        if (activeTab === 'PARCEL') {
            setMultuGroupSelectedArray([]);
            setMultuLayerSelectedArray([]);
            setMultiLayerSelected(false);
            setGreoupingSelected(false);
            polygonCustomLayerRef.current.greoupingSelectedExternalSet(false);
            polygonCustomLayerRef.current.multiLayerSelectedExternalSet(false);
        }
        if (activeTab === 'MULTILAYER') {
            setMultiLayerSelected(true);
        }
        if (activeTab === 'GROUP') {
            setGreoupingSelected(true);
            setMultiLayerSelected(false);
        }
        if (polygonCustomLayerRef.current) {
            polygonCustomLayerRef.current.resetfeatureOpacities(fmesh);
        }
    }, [activeTab, setMultiLayerSelected, multiLayerSelected, setGreoupingSelected]);

    useEffect(() => {
        if (polygonCustomLayerRef.current) {
            if (multiLayerSelected) {
                polygonCustomLayerRef.current.multiLayerSelectedExternalSet(true)
            } else {
                polygonCustomLayerRef.current.multiLayerSelectedExternalSet(false)
            }
        }
    }, [multiLayerSelected, polygonCustomLayerRef])

    useEffect(() => {
        if (polygonCustomLayerRef.current) {
            if (greoupingSelected) {
                polygonCustomLayerRef.current.greoupingSelectedExternalSet(true)
            } else {
                polygonCustomLayerRef.current.greoupingSelectedExternalSet(false)
            }
        }
    }, [greoupingSelected, polygonCustomLayerRef])

    function roundToTwoDecimals(value) {
        return typeof value === 'number' ? Math.round(value * 100) / 100 : value;
    }

    function formatAllMetricsForYear(featureDataTimeseries, selectedYear) {
        let availableMetrics = Object.keys(featureDataTimeseries).filter(m => m !== 'coordinates');
        let yearDataExists = availableMetrics.some(metric => featureDataTimeseries[metric]?.[selectedYear] !== undefined);
        {
            availableMetrics.map((metric) => {
                return null;
            })
        }
        return (
            <div className="clickedInfoTable">
                <div>
                    {availableMetrics.map((metric) => {
                        let value = featureDataTimeseries?.[metric]?.[selectedYear];
                        if (value !== undefined) {
                            if (metric === "BoundaryChange") {
                                value = value === "000,000" ? "False" : "True";
                            } else if (typeof value === "object") {
                                value = JSON.stringify(value); // Convert objects to a string
                            } else if (!isNaN(value) && value !== null && value !== "") {
                                value = roundToTwoDecimals(value); // Format numbers
                            }
                        } else {
                            value = "";
                        }
                        const truncatedValue = value.length > 10 ? `${value.substring(0, 10)}…` : value;
                        return (
                            <div key={metric} className="clickedInfoRow">
                                <div className="clickedInfoLeftHandColumnInline">{metric.substring(0, 20)}: {truncatedValue}</div>
                            </div>
                        );
                    })}
                    {!yearDataExists && (
                        <div className="noDataMessage">
                            <div colSpan="2">No data available for the selected year</div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    const toggleDrawer = () => {
        setIsVisible(false);
        setIsRighdivrawerVisible(!isRighdivrawerVisible);
    };

    useEffect(() => {
        if (clickedInfoHeader !== null) {
            for (let feature of originalGeoJSONforComparingRef.current.features) {
                if (feature.skylark_id === clickedInfoHeader) {
                    const timeseriesData = feature.feature_data_simple_timeseries;
                    setSelectedMetricValue(roundToTwoDecimals(timeseriesData[selectedMetric]?.[selectedYearEditing]) || "No data available");
                    setmodalOtherOriginal(formatAllMetricsForYear(timeseriesData, selectedYearEditing));
                    setModalSkylarkId(feature.skylark_id.substring(0, 15) + '...');
                    setSelectedKeyValue(timeseriesData[landKeySelectedKey]?.[selectedYearEditing]);
                }
            }
        }
        if (clickedInfoHeader !== null) {
            for (let feature of longstandingGeoJSONRef.current.features) {
                if (feature.skylark_id === clickedInfoHeader) {
                    const timeseriesData = feature.feature_data_simple_timeseries;
                    setSelectedMetricValue(roundToTwoDecimals(timeseriesData[selectedMetric]?.[selectedYearEditing]) || "No data available");
                    setmodalOtherAmended(formatAllMetricsForYear(timeseriesData, selectedYearEditing));
                    setModalSkylarkId(feature.skylark_id.substring(0, 15) + '...');
                    setSelectedKeyValue(timeseriesData[landKeySelectedKey]?.[selectedYearEditing]);
                }
            }
        }
    }, [clickedInfoHeader, selectedYearEditing, selectedMetric, longstandingGeoJSONRef, hasChangedKeyValue, landKeySelectedKey, longstandingGeoJSONRef.current]);

    // CALCULATE TOTAL SUMS AMENDED - - - - - - - - 
    // CALCULATE TOTAL SUMS AMENDED - - - - - - - - 
    // CALCULATE TOTAL SUMS AMENDED - - - - - - - - 
    // CALCULATE TOTAL SUMS AMENDED - - - - - - - - 

    let totalSum = 0;

    useEffect(() => {
        if (longstandingGeoJSONRef.current) {
            for (let i = 0; i < longstandingGeoJSONRef.current.features.length; i++) {
                let metricValue;
                const feature = longstandingGeoJSONRef.current.features[i];
                const deletedYear = feature.feature_data_standard?.deleted;
                if (!deletedYear || deletedYear > selectedYearEditing) {
                    if (feature.feature_data_simple_timeseries[selectedMetric] !== undefined) {
                        metricValue = feature.feature_data_simple_timeseries[selectedMetric][selectedYearEditing];
                        if (metricValue !== undefined) {
                            totalSum += metricValue;
                        }
                    }
                }
            }
        }
        if (typeof totalSum === "number" && !isNaN(totalSum) && totalSum !== 0) {
            setTotalSumMetric(totalSum);
        } else {
            setTotalSumMetric(0);
        }
    }, [selectedMetric, longstandingGeoJSONRef.current, selectedYearEditing]);

    // CALCULATE TOTAL SUMS ORIGINAL - - - - - - - - 
    // CALCULATE TOTAL SUMS ORIGINAL - - - - - - - - 
    // CALCULATE TOTAL SUMS ORIGINAL - - - - - - - - 
    // CALCULATE TOTAL SUMS ORIGINAL - - - - - - - - 

    let totalSumOriginal = 0;

    useEffect(() => {
        function check() {
            if (originalGeoJSONforComparingRef.current) {
                for (let i = 0; i < originalGeoJSONforComparingRef.current.features.length; i++) {
                    let metricValue;
                    if (originalGeoJSONforComparingRef.current.features[i].feature_data_simple_timeseries[selectedMetric] !== undefined) {
                        metricValue = originalGeoJSONforComparingRef.current.features[i].feature_data_simple_timeseries[selectedMetric][selectedYearEditing];
                        if (metricValue !== undefined) {
                            totalSumOriginal += metricValue;
                        }
                    }
                }
            }
            if (typeof totalSumOriginal === "number" && !isNaN(totalSumOriginal) && totalSumOriginal !== 0) {
                setTotalSumMetricOriginal(totalSumOriginal);
            } else {
                setTotalSumMetricOriginal(0);
            }
        }
        check();
    }, [selectedMetric, originalGeoJSONforComparingRef.current, selectedYearEditing, longstandingGeoJSONRef.current]);

    // ORIGINAL PARCEL DETAILS - - - - - 
    // ORIGINAL PARCEL DETAILS - - - - - 
    // ORIGINAL PARCEL DETAILS - - - - - 
    // ORIGINAL PARCEL DETAILS - - - - - 

    useEffect(() => {
        if (multuLayerSelectedArray.length > 0) {
            const details = multuLayerSelectedArray.map(skylarkId => {
                const feature = originalGeoJSONforComparingRef.current.features.find(f => f.skylark_id === skylarkId);
                if (feature) {
                    const layerMatch = layers.find(layer => layer.number === feature.feature_data_standard.layer);
                    const key = layerMatch ? layerMatch.key : "default";
                    const value = layerMatch ? layerMatch.value : "default";
                    const keyResult = (feature?.feature_data_simple_timeseries?.[key]?.[selectedYearEditing] ?? "N/A").toString().slice(0, 10);
                    const shapeArea = feature.feature_data_standard_calculated?.Shape_Area || 0;
                    const rawValue = feature.feature_data_simple_timeseries[value]?.[selectedYearEditing];
                    const numericValues = rawValue !== undefined ? Math.round(rawValue) : undefined;
                    return {
                        skylarkId: feature.skylark_id,
                        layer: feature.feature_data_standard.layer,
                        shapeArea: shapeArea,
                        key: key,
                        keyResult: keyResult,
                        numericValues: numericValues
                    };
                }
                return null;
            }).filter(detail => detail !== null);
            const count = details.length;
            const totalFeaturesCount = longstandingGeoJSONRef.current.features.length;
            setMultilayerOriginalParcelDetails({ details, count, totalFeaturesCount });
            const numericValuesArray = details.map(d => d.numericValue);
            setValuesFromGroupData(numericValuesArray);
        } else {
            setMultilayerOriginalParcelDetails({ details: [], count: 0, totalFeaturesCount: 0 });
            setValuesFromGroupData([]); // Clear values when nothing is selected
        }
    }, [multuLayerSelectedArray, selectedYearEditing, longstandingGeoJSONRef.current]);

    // AMENDED PARCEL DETAILS - - - - - 
    // AMENDED PARCEL DETAILS - - - - - 
    // AMENDED PARCEL DETAILS - - - - - 
    // AMENDED PARCEL DETAILS - - - - - 

    useEffect(() => {
        if (multuLayerSelectedArray.length > 0) {
            const details = multuLayerSelectedArray.map(skylarkId => {
                const feature = longstandingGeoJSONRef.current.features.find(f => f.skylark_id === skylarkId);
                if (feature) {
                    const layerMatch = layers.find(layer => layer.number === feature.feature_data_standard.layer);
                    const key = layerMatch ? layerMatch.key : "default"; // Fallback if no match is found
                    const value = layerMatch ? layerMatch.value : "default";
                    const keyResult = (feature?.feature_data_simple_timeseries?.[key]?.[selectedYearEditing] ?? "N/A").toString().slice(0, 10);
                    const shapeArea = feature.feature_data_standard_calculated?.Shape_Area || 0;
                    const rawValue = feature.feature_data_simple_timeseries[value]?.[selectedYearEditing];
                    const numericValues = rawValue !== undefined ? Math.round(rawValue) : undefined;
                    setValuesFromGroupData(numericValues);
                    return {
                        skylarkId: feature.skylark_id,
                        layer: feature.feature_data_standard.layer,
                        shapeArea: shapeArea,
                        key: key,
                        keyResult: keyResult,
                        numericValues: numericValues,
                        value: value
                    };
                }
                return null;
            }).filter(detail => detail !== null);
            const count = details.length;
            const totalFeaturesCount = longstandingGeoJSONRef.current.features.length;
            setMultilayerParcelDetails({ details, count, totalFeaturesCount });
        } else {
            setMultilayerParcelDetails({ details: [], count: 0, totalFeaturesCount: 0 });
            setValuesFromGroupData([]); // Clear values when nothing is selected
        }
    }, [multuLayerSelectedArray, selectedYearEditing, longstandingGeoJSONRef.current, selectedMetric, landKeySelectedKey]);

    // PARCEL COMBINED BAR CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 
    // PARCEL COMBINED BAR CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 
    // PARCEL COMBINED BAR CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 
    // PARCEL COMBINED BAR CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 

    useEffect(() => {
        const ctxPDFCombined = document.getElementById("PDFcombinedParcelSummary")?.getContext("2d");
        if (!ctxPDFCombined) return;
        if (PDFcombinedChartRef.current) {
            PDFcombinedChartRef.current.destroy();
        }
        const selectedDetail = multiParcelDetails?.details?.[0];
        const originalSelectedDetail = multilayerOriginalParcelDetails?.details?.[0];
        if (!selectedDetail) return;
        const selectedValue = selectedDetail.numericValues || 0;
        const originalSelectedValue = originalSelectedDetail.numericValues || 0;
        const labels = [
            "Original Parcel Value",
            "Amended Parcel Value",
        ];
        const dataValues = [
            originalSelectedValue,
            selectedValue,
        ];
        const backgroundColors = [
            "#4C5758",
            "#29645D",
        ];
        PDFcombinedChartRef.current = new Chart(ctxPDFCombined, { type: "bar", data: { labels, datasets: [{ label: "Parcel Metrics Comparison", data: dataValues, backgroundColor: backgroundColors, borderRadius: 4 }] }, options: { plugins: { legend: { display: false }, tooltip: { enabled: true } }, animation: false, scales: { y: { beginAtZero: true, ticks: { precision: 0 } } } } });
    }, [multiGroupDetails, multuLayerSelectedArray, longstandingGeoJSONRef, selectedMetric, landKeySelectedKey, multiParcelDetails]);

    // - - - - - - - - - - - - 
    // - - - - - - - - - - - - 
    // - - - - - - - - - - - - 
    // - - - - - - - - - - - - 

    function formatTotalSums(totalSums) {
        let availableMetrics = Object.keys(totalSums);
        let yearDataExists = availableMetrics.length > 0;
        return (
            <div className='clickedInfoTable'>
                <div>
                    {availableMetrics.map((metric) => (
                        <div key={metric}>
                            <div className="clickedInfoLeftHandColumn">{metric.substring(0, 20)}:</div>
                            <div className="clickedInfoRightHandColumn">
                                {totalSums[metric] !== undefined
                                    ? roundToTwoDecimals(totalSums[metric])
                                    : "No data available"}
                            </div>
                        </div>
                    ))}
                    {!yearDataExists && <div><div colSpan="2">No data available for the selected year</div></div>}
                </div>
            </div>
        );
    }

    useEffect(() => {
        if (multuGroupSelectedArray) {
            if (multuGroupSelectedArray.length > 1) {
                setMoreThenOnePolygonSelected(false)
            } else {
                setMoreThenOnePolygonSelected(true)
            }
        }

    }, [multuGroupSelectedArray])

    // ORIGINAL GROUP DETAILS - - - - - 
    // ORIGINAL GROUP DETAILS - - - - - 
    // ORIGINAL GROUP DETAILS - - - - - 
    // ORIGINAL GROUP DETAILS - - - - - 

    useEffect(() => {
        if (multuGroupSelectedArray.length > 0) {
            const details = multuGroupSelectedArray.map(skylarkId => {
                const feature = originalGeoJSONforComparingRef.current.features.find(f => f.skylark_id === skylarkId);
                if (feature) {
                    const layerMatch = layers.find(layer => layer.number === feature.feature_data_standard.layer);
                    const key = layerMatch ? layerMatch.key : "default";
                    const value = layerMatch ? layerMatch.value : "default";
                    const keyResult = feature.feature_data_simple_timeseries[key]?.[selectedYearEditing] ?? "N/A";
                    const shapeArea = feature.feature_data_standard_calculated?.Shape_Area || 0;
                    const rawValue = feature.feature_data_simple_timeseries[value]?.[selectedYearEditing];
                    const numericValues = rawValue !== undefined ? Math.round(rawValue) : undefined;
                    return {
                        skylarkId: feature.skylark_id,
                        layer: feature.feature_data_standard.layer,
                        shapeArea: shapeArea,
                        key: key,
                        keyResult: keyResult,
                        numericValues: numericValues
                    };
                }
                return null;
            }).filter(detail => detail !== null);
            const count = details.length;
            const totalFeaturesCount = longstandingGeoJSONRef.current.features.length;
            setMultilayerOriginalGroupDetails({ details, count, totalFeaturesCount });
            const numericValuesArray = details.map(d => d.numericValue);
            setValuesFromGroupData(numericValuesArray);
        } else {
            setMultilayerOriginalGroupDetails({ details: [], count: 0, totalFeaturesCount: 0 });
            setValuesFromGroupData([]); // Clear values when nothing is selected
        }
    }, [multuGroupSelectedArray, selectedYearEditing, longstandingGeoJSONRef.current]);

    // AMENDED GROUP DETAILS - - - - - 
    // AMENDED GROUP DETAILS - - - - - 
    // AMENDED GROUP DETAILS - - - - - 
    // AMENDED GROUP DETAILS - - - - - 

    useEffect(() => {
        if (multuGroupSelectedArray.length > 0) {
            const details = multuGroupSelectedArray.map(skylarkId => {
                const feature = longstandingGeoJSONRef.current.features.find(f => f.skylark_id === skylarkId);
                if (feature) {
                    const layerMatch = layers.find(layer => layer.number === feature.feature_data_standard.layer);
                    const key = layerMatch ? layerMatch.key : "default"; // Fallback if no match is found
                    const value = layerMatch ? layerMatch.value : "default";
                    const keyResult = feature.feature_data_simple_timeseries[key]?.[selectedYearEditing] ?? "N/A";
                    const shapeArea = feature.feature_data_standard_calculated?.Shape_Area || 0;
                    const rawValue = feature.feature_data_simple_timeseries[value]?.[selectedYearEditing];
                    const numericValues = rawValue !== undefined ? Math.round(rawValue) : undefined;
                    setValuesFromGroupData(numericValues);
                    return {
                        skylarkId: feature.skylark_id,
                        layer: feature.feature_data_standard.layer,
                        shapeArea: shapeArea,
                        key: key,
                        keyResult: keyResult,
                        numericValues: numericValues
                    };
                }
                return null;
            }).filter(detail => detail !== null);
            const count = details.length;
            const totalFeaturesCount = longstandingGeoJSONRef.current.features.length;
            setMultilayerGroupDetails({ details, count, totalFeaturesCount });
        } else {
            setMultilayerGroupDetails({ details: [], count: 0, totalFeaturesCount: 0 });
            setValuesFromGroupData([]); // Clear values when nothing is selected
        }
    }, [multuGroupSelectedArray, selectedYearEditing, longstandingGeoJSONRef.current, selectedMetric, landKeySelectedKey]);

    // GROUP AMENDED Parcel CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 
    // GROUP AMENDED Parcel CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 
    // GROUP AMENDED Parcel CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 
    // GROUP AMENDED Parcel CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 

    useEffect(() => {
        const ctxPDFgroupsummary = document.getElementById("PDFgroupsummary")?.getContext("2d");
        // if (ctxPDFgroupRef.current) {
        //     ctxPDFgroupRef.current.destroy();
        // }
        const tempArray = [];
        fmesh.traverse((child) => {
            if (child.isMesh) {
                longstandingGeoJSONRef.current.features.forEach((feature) => {
                    if (child.name === feature.skylark_id) {
                        const timeSeriesData = feature.feature_data_simple_timeseries[landKeySelectedKey]?.[selectedYearEditing];
                        if (timeSeriesData) {
                            const r = Math.round(child.material.color.r * 255);
                            const g = Math.round(child.material.color.g * 255);
                            const b = Math.round(child.material.color.b * 255);
                            const hexColor = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
                            const uniqueEntry = { timeSeriesData, color: hexColor };
                            if (!tempArray.some((entry) => entry.timeSeriesData === uniqueEntry.timeSeriesData && entry.color === uniqueEntry.color)) {
                                tempArray.push(uniqueEntry);
                            }
                        }
                    }
                });
            }
        });
        if (multiGroupDetails?.details?.length > 0) {
            const details = multiGroupDetails.details;
            const labels = details.map((d, i) => `Feature ${i + 1} (${d.skylarkId})`);
            const labelsForColour = details.map(d => d.keyResult);
            const dataValues = details.map(d => d.numericValues || 0);
            const differentiatorColorMap = {};
            tempArray.forEach((entry) => {
                differentiatorColorMap[entry.timeSeriesData] = entry.color;
            });
            const backgroundColors = labelsForColour.map((labelForColour) => differentiatorColorMap[labelForColour] || "#ccc");
            ctxPDFgroupRef.current = new Chart(ctxPDFgroupsummary, { type: "Parcel", data: { labels: labels, datasets: [{ data: dataValues, backgroundColor: backgroundColors, hoverOffset: 4, },], }, options: { plugins: { legend: { display: false, }, tooltip: { enabled: true, }, }, animation: false, }, });
        }
        let PDFgroupByKeysummaryctx = document.getElementById("PDFgroupByKeysummary")?.getContext("2d");
        if (ParcelcharbykeytRef.current) {
            ParcelcharbykeytRef.current.destroy();
        }
        if (multiGroupDetails?.details?.length > 0) {
            const details = multiGroupDetails.details;
            const aggregatedData = {};
            details.forEach((d) => {
                const key = d.keyResult;
                const value = d.numericValues || 0;
                if (!aggregatedData[key]) {
                    aggregatedData[key] = value;
                } else {
                    aggregatedData[key] += value;
                }
            });
            const labels = Object.keys(aggregatedData);
            const dataValues = Object.values(aggregatedData);
            const differentiatorColorMap = {};
            tempArray.forEach((entry) => {
                differentiatorColorMap[entry.timeSeriesData] = entry.color;
            });
            const backgroundColors = labels.map(
                (label) => differentiatorColorMap[label] || "#ccc"
            );
            ParcelcharbykeytRef.current = new Chart(PDFgroupByKeysummaryctx, { type: "Parcel", data: { labels: labels, datasets: [{ data: dataValues, backgroundColor: backgroundColors, hoverOffset: 4, },], }, options: { plugins: { legend: { display: false, }, tooltip: { enabled: true, }, }, animation: false, }, });
        }
    }, [multiGroupDetails, longstandingGeoJSONRef, selectedMetric, landKeySelectedKey]);

    // GROUP ORIGINAL Parcel CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 
    // GROUP ORIGINAL Parcel CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 
    // GROUP ORIGINAL Parcel CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 
    // GROUP ORIGINAL Parcel CHART SETTINGS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 

    useEffect(() => {
        const ctxPDFgrouporiginalsummary = document.getElementById("PDFgrouporiginalsummary")?.getContext("2d");
        if (ParcelchartoriginalRef.current) {
            ParcelchartoriginalRef.current.destroy();
        }
        const tempArray = [];
        fmesh.traverse((child) => {
            if (child.isMesh) {
                longstandingGeoJSONRef.current.features.forEach((feature) => {
                    if (child.name === feature.skylark_id) {
                        const timeSeriesData = feature.feature_data_simple_timeseries[landKeySelectedKey]?.[selectedYearEditing];
                        if (timeSeriesData) {
                            const r = Math.round(child.material.color.r * 255);
                            const g = Math.round(child.material.color.g * 255);
                            const b = Math.round(child.material.color.b * 255);
                            const hexColor = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
                            const uniqueEntry = { timeSeriesData, color: hexColor };
                            if (!tempArray.some((entry) => entry.timeSeriesData === uniqueEntry.timeSeriesData && entry.color === uniqueEntry.color)) {
                                tempArray.push(uniqueEntry);
                            }
                        }
                    }
                });
            }
        });
        if (multilayerOriginalGroupDetails?.details?.length > 0) {
            const details = multilayerOriginalGroupDetails.details;
            const labels = details.map((d, i) => `Feature ${i + 1} (${d.skylarkId})`);
            const labelsForColour = details.map(d => d.keyResult);
            const dataValues = details.map(d => d.numericValues || 0);
            const differentiatorColorMap = {};
            tempArray.forEach((entry) => {
                differentiatorColorMap[entry.timeSeriesData] = entry.color;
            });
            const backgroundColors = labelsForColour.map((labelForColour) => differentiatorColorMap[labelForColour] || "#ccc");
            ParcelchartoriginalRef.current = new Chart(ctxPDFgrouporiginalsummary, { type: "Parcel", data: { labels: labels, datasets: [{ data: dataValues, backgroundColor: backgroundColors, hoverOffset: 4, },], }, options: { plugins: { legend: { display: false, }, tooltip: { enabled: true, }, }, animation: false, }, });
        }
        let PDFgroupByKeyoriginalsummaryctx = document.getElementById("PDFgroupByKeyoriginalsummary")?.getContext("2d");
        if (ParcelcharbykeytoriginalRef.current) {
            ParcelcharbykeytoriginalRef.current.destroy();
        }
        if (multilayerOriginalGroupDetails?.details?.length > 0) {
            const details = multilayerOriginalGroupDetails.details;
            const aggregatedData = {};
            details.forEach((d) => {
                const key = d.keyResult;
                const value = d.numericValues || 0;
                if (!aggregatedData[key]) {
                    aggregatedData[key] = value;
                } else {
                    aggregatedData[key] += value;
                }
            });
            const labels = Object.keys(aggregatedData);
            const dataValues = Object.values(aggregatedData);
            const differentiatorColorMap = {};
            tempArray.forEach((entry) => {
                differentiatorColorMap[entry.timeSeriesData] = entry.color;
            });
            const backgroundColors = labels.map(
                (label) => differentiatorColorMap[label] || "#ccc"
            );
            ParcelcharbykeytoriginalRef.current = new Chart(PDFgroupByKeyoriginalsummaryctx, { type: "Parcel", data: { labels: labels, datasets: [{ data: dataValues, backgroundColor: backgroundColors, hoverOffset: 4, },], }, options: { plugins: { legend: { display: false, }, tooltip: { enabled: true, }, }, animation: false, }, });
        }

    }, [multiGroupDetails, longstandingGeoJSONRef, selectedMetric, landKeySelectedKey]);

    // COMBINED GROUP BAR CHART - - - - - - - - - - - - 
    // COMBINED GROUP BAR CHART - - - - - - - - - - - - 
    // COMBINED GROUP BAR CHART - - - - - - - - - - - - 
    // COMBINED GROUP BAR CHART - - - - - - - - - - - - 

    useEffect(() => {
        const ctxGroupCombined = document
            .getElementById("combinedPDFgroupsummary")
            ?.getContext("2d");
        if (!ctxGroupCombined) return;
        if (combinedGroupChartRef.current) {
            combinedGroupChartRef.current.destroy();
        }
        const amendedParcelTotal = multiGroupDetails?.details?.reduce((sum, d) => sum + (d.numericValues || 0), 0) || 0;
        const originalParcelTotal = multilayerOriginalGroupDetails?.details?.reduce((sum, d) => sum + (d.numericValues || 0), 0) || 0;
        const globalValueKey = multiGroupDetails?.details?.[0]?.value || multiGroupDetails?.details?.[0]?.keyResult || null;
        if (!globalValueKey) return;
        const labels = [
            "Original Parcel Total",
            "Amended Parcel Total",
        ];
        const dataValues = [
            originalParcelTotal,
            amendedParcelTotal,
        ];
        const backgroundColors = [
            "#4C5758",
            "#29645D",
        ];
        combinedGroupChartRef.current = new Chart(ctxGroupCombined, { type: "bar", data: { labels, datasets: [{ label: "Value Comparison", data: dataValues, backgroundColor: backgroundColors, borderRadius: 6, },], }, options: { plugins: { legend: { display: false }, tooltip: { enabled: true }, }, animation: false, scales: { y: { beginAtZero: true, ticks: { precision: 0 }, }, }, }, });
    }, [multiGroupDetails, multilayerOriginalGroupDetails, longstandingGeoJSONRef, originalGeoJSONforComparingRef, selectedMetric, landKeySelectedKey, selectedYearEditing,
    ]);

    // - - - - - - - - 
    // - - - - - - - - 
    // - - - - - - - - 
    // - - - - - - - - 

    const handleRemoveDetail = (indexToRemove) => {
        setMultilayerGroupDetails((prev) => {
            const updatedDetails = prev.details.filter((_, i) => i !== indexToRemove);
            const newState = {
                ...prev,
                details: updatedDetails,
                count: updatedDetails.length,
            };
            // If this was the last item, reset feature opacities
            if (updatedDetails.length === 0) {
                polygonCustomLayerRef.current.resetfeatureOpacities(fmesh);
            }
            return newState;
        });
        // Safely retrieve the skylarkId to remove
        const removedSkylarkId = multiGroupDetails.details[indexToRemove]?.skylarkId;
        if (removedSkylarkId) {
            polygonCustomLayerRef.current.removedSkylarkIdFromsetMultuGroupSelectedArray(removedSkylarkId);
        }
    };

    const handleRemoveParcel = () => {
        setMultuLayerSelectedArray([]);
        setMultuGroupSelectedArray([]);
        polygonCustomLayerRef.current.greoupingSelectedExternalSet(false);
        polygonCustomLayerRef.current.multiLayerSelectedExternalSet(false);
        setIsVisible(false);
        polygonCustomLayerRef.current.resetfeatureOpacities(fmesh);
        polygonCustomLayerRef.current.individuallySelectedParcel(false)
    }

    useEffect(() => {
        if (layers.length > 0) {
            setMoreThenOneLayer(true);
        } else {
            setMoreThenOneLayer(false);
        }
    }, [layers])

    const tabIcons = {
        TOTAL: <MdOutlineAddToPhotos />,
        GROUP: <CgMenuGridO />,
        MULTILAYER: <MdOutlineLayers />
    };

    return (

        <>
            <button className={`togglerRightDrawInside`} onClick={toggleDrawer}>
                <IoIosArrowBack />
            </button>

            <div style={{
                fontSize: '12px',
                position: 'absolute',
                zIndex: '100000000',
                width: '455px',
                left: '25px',
                top: '800px',
                height: 'auto',
                backgroundColor: ' white',
            }} ref={PDFParcelInfoRef}>
                <BrowserView>

                    {activeTab === "GROUP" && (
                        <div className='clicked_info_inner'>
                            {multiGroupDetails?.details?.length > 0 ? (
                                <>
                                    <div className="clicked_info_inner_inner" >
                                        <div style={{ textAlign: 'left', width: 'calc(49% - 7.5px)', color: '#fff', paddingLeft: '5px', backgroundColor: '#4C5758', height: '30px', display: 'inline-block' }}>
                                            <h3 style={{ marginTop: '0px', marginBottom: '0px', }}>Original</h3>
                                        </div>
                                        <div style={{ textAlign: 'left', width: 'calc(49% - 7.5px)', color: '#fff', paddingLeft: '5px', backgroundColor: '#4C5758', height: '30px', display: 'inline-block' }}>
                                            <h3 style={{ marginTop: '0px', marginBottom: '0px', }}>Amended</h3>
                                        </div>
                                        <div id="originalDataContainer" style={{ height: 'auto', width: '49%', backgroundColor: 'transparent', display: 'inline-block' }}>
                                            {multilayerOriginalGroupDetails.details.map((detail, index) => (
                                                <div key={detail.skylarkId || index} style={{
                                                    paddingTop: '5px',
                                                    paddingLeft: '5px',
                                                    width: '95%',
                                                    height: '100px',
                                                    backgroundColor: '#F2F1F6',
                                                }} >
                                                    <div>
                                                        <div style={{
                                                            fontSize: '12px',
                                                            display: 'inline-block',
                                                        }}>{detail.key} </div>
                                                        <div style={{
                                                            fontSize: '12px',
                                                            display: 'inline-block',
                                                        }}><b>{detail.keyResult}</b></div>
                                                        <div style={{
                                                            fontSize: '12px',
                                                            display: 'inline-block',
                                                        }}>{selectedMetric}: </div>
                                                        <div style={{
                                                            fontSize: '12px',
                                                            display: 'inline-block',
                                                        }}><b>{detail.numericValues}</b></div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div id="amendedDataContainer" style={{
                                            height: 'auto', width: '49%', backgroundColor: 'transparent', display: 'inline-block', position: 'relative'
                                        }}>
                                            {multiGroupDetails.details.map((detail, index) => (
                                                <div key={detail.skylarkId || index} style={{
                                                    paddingTop: '5px',
                                                    paddingLeft: '5px',
                                                    width: '95%',
                                                    height: '100px',
                                                    backgroundColor: '#F2F1F6',
                                                }} >
                                                    <div>
                                                        <div style={{
                                                            fontSize: '12px',
                                                            display: 'inline-block',
                                                        }}>{detail.key} </div>
                                                        <div style={{
                                                            fontSize: '12px',
                                                            display: 'inline-block',
                                                        }}><b>{detail.keyResult}</b></div>
                                                        <div style={{
                                                            fontSize: '12px',
                                                            display: 'inline-block',
                                                        }}>{selectedMetric}: </div>
                                                        <div style={{
                                                            fontSize: '12px',
                                                            display: 'inline-block',
                                                        }}><b>{detail.numericValues}</b></div>
                                                    </div>
                                                </div>
                                            ))
                                            }
                                        </div>
                                    </div>


                                    {/* <div id="originalParcelContainer" style={{ marginTop: '25px', width: '100%', backgroundColor: '#fff', height: 'auto', display: 'inline-block', float: 'left' }}>
                                        <div style={{ width: '100%', height: '250px;', top: '0px', position: 'relative' }}>
                                            <canvas id="combinedPDFgroupsummary" height="300" />
                                        </div>
                                    </div> */}
                                    
                                </>
                            ) : (
                                <>
                                    <div className='clickedInfoRightHandColumn'>
                                        No data available
                                    </div>
                                    <div className='clickedInfoLeftHandColumn'>
                                        Please Select a Parcel to begin viewing Group information
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {activeTab === "MULTILAYER" && (
                        <div className='clicked_info_inner'>
                            {multilayerDetails.length > 0 ? (
                                <>
                                    {moreThanOneLayer && multilayerDetails.map((detail, index) => (
                                        <div key={index}>
                                            <div>ID: {detail.skylarkId}</div>
                                            <div>Layer: {detail.layer}</div>
                                            <div>Key: {detail.key}</div>
                                            <div>Value: {detail.value}</div>
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <>
                                    <div className='clickedInfoRightHandColumn'>
                                        No data available
                                    </div>
                                    <div className='clickedInfoLeftHandColumn'>
                                        The MultiLayer feature recognises features across multiple Layers.<br /><br />
                                        Your Map currently only has 1 layer available,<br /><br />
                                        Please use the Layers Panel on the left to add a new Layer.
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                </BrowserView>
            </div >
        </>

    );
};

export default PDFParcelInfo;
